"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteMessage = void 0;
const base_html_1 = require("./base-html");
class InviteMessage {
    constructor(employee, company, invitor, url) {
        this.employee = employee;
        this.company = company;
        this.invitor = invitor;
        this.url = url;
        this.title = `Ihr Mitarbeiterzugang für "${this.company.name}"`;
    }
    get recipient() {
        return this.employee.email;
    }
    get replyTo() {
        return this.invitor.email;
    }
    get text() {
        return `
Hallo ${this.employee.name},

${this.invitor.name} hat Sie eingeladen, Ihren Mitarbeiterzugang für das Unternehmen "${this.company.name}" einzurichten. ${this._invite.message
            ? `

Nachricht: "${this._invite.message}"`
            : ""}

Öffnen Sie den folgenden Link in Ihrem Browser, um die Einladung zu beantworten:

${this.url}

Mit freundlichen Grüßen,
Ihr Pentacode Team
`;
    }
    get html() {
        return (0, base_html_1.base)(`
            ${(0, base_html_1.paragraph)(`Hallo ${this.employee.name},`)}

            ${(0, base_html_1.paragraph)(`${this.invitor.name} hat Sie eingeladen, Ihren Mitarbeiterzugang für das Unternehmen "${this.company.name}" einzurichten.`)}

            ${this._invite.message ? (0, base_html_1.paragraph)(`Nachricht: "<b>${this._invite.message}"</b>`) : ""}

            ${(0, base_html_1.button)("Einladung Beantworten", this.url)}

            ${(0, base_html_1.paragraph)(`
                Mit freundlichen Grüßen,<br>
                Dein Pentacode Team
            `)}
        `);
    }
    get _invite() {
        return this.employee.invite;
    }
}
exports.InviteMessage = InviteMessage;
//# sourceMappingURL=invite.js.map